import { PAGE_MODE } from "../../../constants/constants";
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../framework/bar-button/BarButtonFw";
import GridFw, {
  COLUMN_DEFAULT,
  SELECTION_TYPE,
} from "../../../framework/grid/GridFw";
import FormFw from "../../../framework/form/FormFw";
import { S3Util } from "../../../util/S3Util";
import confirm from "antd/lib/modal/confirm";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { MessageUtil } from "../../../util/MessageUtil";

const EquiposUtilizadosModal = (props) => {
  const { api, history, cambiarTabPanel, gridsConfig = [], name } = props;
  const getForm = () => api.getComponent("form");
  const getGridequiposAsociados = () =>
    api.getComponent("gridequiposAsociados");
  const getGridequiposAdicionales = () =>
    api.getComponent("gridequiposAdicionales");

    const getform_cabeceraSS = () =>
      api.getComponent("form_cabeceraSS");

  const gridBarHeaderButtonconfig2 = {
    fields: [
      {
        ...BUTTON_DEFAULT.DELETE,
        label: `Eliminar Seleccionados`,
        onClick: () => {
          const items = getGridequiposAsociados().getSelectedItem();

          if (items?.length > 0) {
            confirm({
              title: "¿Esta seguro de eliminar los registros seleccionados?",
              icon: <ExclamationCircleOutlined />,
              onOk() {
                items.forEach((el) =>
                  getGridequiposAsociados().deleteItem(el.key),
                );
                getGridequiposAsociados().refresh();
              },
              onCancel() {},
            });
          } else {
            MessageUtil("warning", "Aun no has seleccionado ningún equipo.");
          }
        },
      },
    ],
  };

      const form_cabeceraSS = {
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 354,
        params: {
          ID_CADENA: api.getParamId(),
        },
      },
      save: {
        queryId: 0,
        params: { ID_CADENA: api.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      }, 
      title: "",
      collapsible: true,
      fields: [
        {
          label: "  ",
          fields: [
            { type: "hidden", name: "ID_SOLICITUD_SERVICIO" },
            {name: 'nro_ss_cadena', label: ' ',column: 7,readOnly: true} ,
          ],
        },
      ],
      onComponentLoad: (formApi, api) => {
        if (api.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };


  const gridConfigequiposAsociados = {
    layout: "vertical",
    title: "Equipos Asociados",
    showIndex: true,
    autoLoad: true,
    pagination: {
      server: false,
      showSizeChanger: true,
    },
    rowId: "ID_RECURSO_INSTRUMENTO",
    barHeader: gridBarHeaderButtonconfig2,
    selection: { type: SELECTION_TYPE.MULTIPLE },
    load: {
      queryId: 888,
      hideMessage: true,
      hideMessageError: true,
      params: { ID_CADENA: api.getParamId() },
    },
    save: {
      queryId: 889,
      hideMessage: true,
      hideMessageError: true,
      fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, "");
               gridConfigequiposAsociados().load();
            } 
      },   
    },
    fields: [
            {
        type: "select",
        name: "id_metodo",
        label: "Parametro",
        labelName: "nom_metodo",
        column: 4,
        search: true,
        allowClear: true,
        editable: true,
        load: {
          queryId: 984,
          params: {
            ID_CADENA: api.getParamId() 
          }, 
        }, 
      },
      {
        type: "select",
        name: "id_muestreo",
        label: "Estacion",
        labelName: "nom_muestra",
        column: 4,
        search: true,
        multiple: true,
        multipleInString: true,
        allowClear: true,
        editable: true,
        load: {
          queryId: 984,
          params: {
            ID_CADENA: api.getParamId() 
          }, 
        }, 
         parents: [
          {
            name: "id_metodo",
            paramName: "id_metodo",
            required: true,
          },
        ],
      },   
      {
        type: "select",
        name: "id_codigo_equipo",
        label: "Código Interno",
        labelName: "cod_equipo",
        column: 4,
        search: true,
        allowClear: true,
        editable: true,
        onChange: async (value, row, formApi) => {
          const equipo = formApi.getFieldApi("id_codigo_equipo")?.dataList?.find(el => el.value === value);
          const item = getGridequiposAsociados().itemEditing;

          if (equipo) {
            getGridequiposAsociados().saveItemEditing();
            const arrMuestreo = getGridequiposAsociados().getData();

            setTimeout(() => {
              arrMuestreo.forEach(el => {
                if (item.key === el.key) {
                  getGridequiposAsociados().updateItem({
                    ...el,
                    ...item,
                    ID_MARCA_EQUIPO: equipo?.ID_MARCA_EQUIPO,
                    MARCA: equipo?.MARCA,
                  })
                } else {
                  getGridequiposAsociados().updateItem(el)
                }
              });
            }, 0)
          }
        },
        load: {
          queryId: 388,
          params: () => ({
            id_equipo: getGridequiposAsociados()?.itemEditing?.id_equipo
          }),
          fnOk: (resp) => {
            array_cod_equipo = resp.dataList;
          },
        },
      },
      { name: "NOMBRE", label: "Nombre" },
      { name: "MARCA", label: "Marca" },
      {
        type: "select",
        name: "id_punto_calibracion",
        label: "Certificación",
        labelName: "punto_calibracion",
        editable: true,
        width: 70,
        load: {
          queryId: 912,
          fnOk: (resp) => {
            lista_documento = resp.dataList;
          },
        },
        parents: [
          {
            name: "id_codigo_equipo",
            paramName: "ID_COD_EQUIPO",
            required: true,
          },
        ],
      },
      {
        ...COLUMN_DEFAULT.DELETE,
        label: "Opciones",
        onClick: (_v, row, _i) => {
          getGridequiposAsociados().deleteItem(row.key);
          getGridequiposAsociados().refresh();
        },
        confirm: false,
      },
    ],
    onComponentLoad: (formApi, api) => {
      if (api.getPageMode() !== PAGE_MODE.NEW) formApi.load();
    },
  };

  const form = {
    layout: "vertical",
    autoLoad: true,
    load: {
      queryId: 354,
      params: {
        ID_CADENA: api.getParamId(),
      },
    },
    title: "",
    collapsible: true,
    fields: [],
    onComponentLoad: (formApi, api) => {
      if (api.getPageMode() !== PAGE_MODE.NEW) formApi.load();
    },
  };

  const gridBarHeaderButtonconfig3 = {
    fields: [
      {
        ...BUTTON_DEFAULT.ADD,
        label: `Adicionar Equipo`,
        onClick: () => {
          getGridequiposAdicionales().addItem({}, true);
        },
      },
    ],
  };

  let array_cod_equipo = [];
  let lista_documento = [];
  const gridConfigequiposAdicionales = {
    title: "Equipos Adicionales",
    showIndex: true,
    autoLoad: true,
    pagination: {
      server: false,
      showSizeChanger: true,
    },
    rowId: "ID_EQUIPO_CAMPO",
    barHeader: gridBarHeaderButtonconfig3,
    load: {
      queryId: 384,
      params: { ID_CADENA: api.getParamId() },
      hideMessage: true,
      hideMessageError: true,
    },
    save: {
      queryId: 383,
      hideMessage: true,
      hideMessageError: true,
      fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, "");
               gridConfigequiposAdicionales().load();
            } 
      }, 
    },
    dataOptions: {
      out: { includeLabel: true },
    },
    fields: [
      {
        type: "select",
        name: "id_metodo",
        label: "Parametro",
        labelName: "nom_metodo",
        column: 4,
        search: true,
        allowClear: true,
        editable: true,
        load: {
          queryId: 984,
          params: {
            ID_CADENA: api.getParamId() 
          }, 
        }, 
      },
      {
        type: "select",
        name: "id_muestreo",
        label: "Estacion",
        labelName: "nom_muestra",
        column: 4,
        search: true,
        multiple: true,
        multipleInString: true,
        allowClear: true,
        editable: true,
        load: {
          queryId: 984,
          params: {
            ID_CADENA: api.getParamId() 
          }, 
        }, 
         parents: [
          {
            name: "id_metodo",
            paramName: "id_metodo",
            required: true,
          },
        ],
      },          
      {
        type: "select",
        name: "ID_COD_EQUIPO",
        label: "Código Interno",
        labelName: "COD_EQUIPO",
        column: 4,
        search: true,
        allowClear: true,
        editable: true,
        load: {
          queryId: 388,
          params: {
            id_tipo: 1, //campo
          },
          fnOk: (resp) => {
            array_cod_equipo = resp.dataList;
          },
        },
        onChange: (value, values, formApi) => {
          let obj = array_cod_equipo.filter((data) => data.value === value);
          obj.forEach((x) => {
            getGridequiposAdicionales().itemEditing.NOMBRE = x.NOMBRE;
            getGridequiposAdicionales().itemEditing.MARCA = x.MARCA;
            lista_documento = [];
          });
          getGridequiposAdicionales().refresh();
        },
      },
      { name: "NOMBRE", label: "Nombre" },
      { name: "MARCA", label: "Marca" },
      {
        type: "select",
        name: "CERTIFICADO_CALIBRACION",
        label: "Certificación",
        editable: true,
        labelName: "CERTIFICADO_CALIBRACION",
        load: {
          queryId: 912,
          fnOk: (resp) => {
            lista_documento = resp.dataList;
          },
        },
        parents: [
          {
            name: "ID_COD_EQUIPO",
            paramName: "ID_COD_EQUIPO",
            required: true,
          },
        ],
        onChange: (value, values, formApi) => {
          if (lista_documento.length > 0) {
            let obj = lista_documento.filter((data) => data.value === value);
            obj.forEach((x) => {
              getGridequiposAdicionales().itemEditing.FILENAME =
                obj[0].FILENAME;
              getGridequiposAdicionales().itemEditing.id_punto_calibracion =
                obj[0].value;
            });
            getGridequiposAdicionales().refresh();
          }
        },
      },
      {
        ...COLUMN_DEFAULT.DELETE,
        label: "Opciones",
        onClick: (_v, row, _i) => {
          getGridequiposAdicionales().deleteItem(row.key);
        },
        confirm: false,
      },
      {
        ...COLUMN_DEFAULT.DOWNLOAD,
        onClick: (value, row, index) => {
          S3Util.donwload(
            row.FILENAME,
            "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia/punto-calibracion",
          );
        },
        fnVisible: (value, row, index) => {
          // eslint-disable-next-line eqeqeq
          return row?.FILENAME != undefined;
        },
      },
    ],
    onComponentLoad: (formApi, api) => {
      if (api.getPageMode() !== PAGE_MODE.NEW) formApi.load();
    },
  };

  const barButtonFooterdatos_servicio = {
    fields: [
      {
        ...BUTTON_DEFAULT.RETURN,
        label: "Retornar Inicio",
        onClick: () => {
          const pathBack = history?.location?.state?.from 
            || `/solicitudes-asignadas/solicitudes-asignadas/${name.id_ss}`;
          history.push(pathBack);
        },
      },
      {
        ...BUTTON_DEFAULT.SAVE,
        label: "Guardar",
        onClick: async () => {
          getGridequiposAsociados().save({
            params: { ID_CADENA: api.getParamId() },
          });
          getGridequiposAdicionales().save({
            params: { ID_CADENA: api.getParamId() },
          });
          gridsConfig?.forEach((g) => {
            const grid = api.getComponent(g.name);
            if (g.readonly !== true) {
              if (grid?.save) {
                grid?.save();
              } else if (grid?.update) {
                grid?.update();
              }
            }
          });
        },
      },
      {
        ...BUTTON_DEFAULT.NEXT,
        label: "Continuar",
        onClick: () => {
          getGridequiposAsociados().save({
            params: { ID_CADENA: api.getParamId() },
          });
          getGridequiposAdicionales().save({
            params: { ID_CADENA: api.getParamId() },
          });
          gridsConfig?.forEach((g) => {
            const grid = api.getComponent(g.name);
            if (g.readonly !== true) {
              if (grid?.save) {
                grid?.save();
              } else if (grid?.update) {
                grid?.update();
              }
            }
          });
          cambiarTabPanel("6", 0);
        },
      },
    ],
  };

  return (
    <>
        <FormFw
          name="form_cabeceraSS"
          getParentApi={api.getApi}
          config={form_cabeceraSS}
        />
      <div style={{ display: "none" }}>
        <FormFw name="form" getParentApi={api.getApi} config={form} />
      </div>
      <GridFw
        name="gridequiposAsociados"
        getParentApi={api.getApi}
        config={gridConfigequiposAsociados}
      />
      <GridFw
        name="gridequiposAdicionales"
        getParentApi={api.getApi}
        config={gridConfigequiposAdicionales}
      />
      {gridsConfig && gridsConfig?.map((grid) => {
        if (grid.type === 'grid') {
          return (
            <GridFw
              key={grid.name}
              name={grid.name}
              getParentApi={api.getApi}
              config={grid.config}
            />
          )
        } else if (grid.type === 'form') {
          return (
            <FormFw
              key={grid.name}
              name={grid.name}
              getParentApi={api.getApi}
              config={grid.config}
            />
          )
        } else {
          return <></>
        }
      })}
      <BarButtonFw
        name="barFooter"
        getParentApi={api.getApi}
        config={barButtonFooterdatos_servicio}
      />
    </>
  );
};

export default EquiposUtilizadosModal;